import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { api } from './services/api';
import auth from './slices/auth.slice';
import notification from './slices/auth.slice';
import latestUnfinishedOrder from './slices/latestUnfinishedOrder.slice';

export const store = configureStore({
  reducer: {
    auth,
    notification,
    latestUnfinishedOrder,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootStateType = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootStateType,
  unknown,
  Action<string>
>;
